import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './Admin.css';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Requests from './components/Requests';
import Planning from './components/Planning';
import Clients from './components/Clients';
import Billing from './components/Billing';
import ServiceCatalog from './components/ServiceCatalog';
import Settings from './components/Settings';

import QuotesList from './components/QuotesList';
import AdminHeader from './components/AdminHeader';

import Messages from './components/Messages';

import PricingRules from './components/PricingRules';
import pb from '../../lib/pocketbase';

const Admin = ({ setCurrentPage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [pendingCount, setPendingCount] = React.useState(0);
    const [agencyData, setAgencyData] = React.useState(null);
    const [unreadCount, setUnreadCount] = React.useState(0);

    const fetchAgencySettings = React.useCallback(async () => {
        try {
            const settings = await pb.collection('company_settings').getList(1, 1);
            if (settings.items.length > 0) {
                setAgencyData(settings.items[0]);
            }
        } catch (err) {
            console.error('Error fetching agency settings:', err);
        }
    }, []);

    const fetchNotifications = React.useCallback(async () => {
        try {
            // Count 1: Unconfirmed existing appointments
            const apps = await pb.collection('appointments').getList(1, 1, {
                filter: 'status = "pending"',
            });
            
            // Count 2: Validated quotes that need planning (Prop 3)
            const quotes = await pb.collection('quotes').getList(1, 1, {
                filter: 'status = "valide"',
            });

            // Count 3: New messages
            const msgs = await pb.collection('messages').getList(1, 1, {
                filter: 'status = "new"',
            });

            setPendingCount(apps.totalItems + quotes.totalItems);
            setUnreadCount(msgs.totalItems);
        } catch (err) {
            console.error('Error fetching admin notifications:', err);
        }
    }, []);

    React.useEffect(() => {
        fetchNotifications();
        fetchAgencySettings();
        const interval = setInterval(fetchNotifications, 30000); // 30s
        return () => clearInterval(interval);
    }, [fetchNotifications, fetchAgencySettings]);

    // Map URL to tab
    const getTabFromPath = () => {
        const path = location.pathname.split('/')[2];
        return path || 'dashboard';
    };

    const currentTab = getTabFromPath();

    const onTabChange = (tab) => {
        navigate(`/admin/${tab === 'dashboard' ? '' : tab}`);
    };

    return (
        <div className="admin-layout">
                <Sidebar 
                    currentTab={currentTab} 
                    onTabChange={onTabChange} 
                    pendingAppointmentsCount={pendingCount}
                    unreadMessagesCount={unreadCount}
                    agencyData={agencyData}
                />
            <main className="admin-main-content">
                <AdminHeader
                    currentTab={currentTab}
                    onBackToSite={() => navigate('/')}
                />
                <div className="admin-body">
                    <Routes>
                        <Route index element={<Dashboard />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="clients" element={<Clients />} />
                        <Route path="requests" element={<Requests />} />
                        <Route path="quotes_list" element={<QuotesList />} />
                        <Route path="billing" element={<Billing />} />
                        <Route path="planning" element={<Planning />} />
                        <Route path="services" element={<ServiceCatalog />} />
                        <Route path="pricing" element={<PricingRules />} />
                        <Route path="messages" element={<Messages onMessageRead={fetchNotifications} />} />
                        <Route path="settings" element={<Settings />} />
                    </Routes>
                </div>
            </main>
        </div>
    );
};

export default Admin;
